import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";
import { string } from "prop-types";
import { DfpComponent } from "./dfp-component";

import "./ads.m.css";

export const TopComponentAd = ({ adSlotLabel = "Advertisement" }) => {
  const adConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "top_component_ad"], {}));
  return (
    <div styleName="ad-wrapper">
      <DfpComponent
        adStyleName="ad-slot-size-300x250"
        id={`ThreeColNineteenStories-ad`}
        path={adConfig.ad_unit}
        size={adConfig.sizes}
        viewPortSizeMapping={adConfig.view_port_size_mapping}
      />
    </div>
  );
};

TopComponentAd.propTypes = {
  adSlotLabel: string,
};
